export class OpColor {
    numer: number = 0
    etap: string = ""
    etap_graflow: any = ""
    technologia: string = ""
    technologia_graflow: string = ""
    kolor:string = ""
    nazwa: string = ""
    wspolnota: string = ""
    angle:number = 0
    lpi:number = 0
    pokrycie_procent: number = 100
    pokrycie_cm: number = 0
    
    miejscowy:number = 0
    used:boolean = true
    _id:any = undefined
    rgb:number[] = []
    cmyk:number[]=[]
    separacja:string = ""
    file_path_128: string = ""
	proofscope_url: string = ""
	separacja_url:string = ""
}